import InitialPageContentWrapperV2 from './InitialPageContentWrapperV2';
import { jsx as _jsx } from "react/jsx-runtime";
const InitialPageContentWrapper = ({
  children,
  widgetLocation,
  isMobile = false,
  usePillLauncher = false
}) => {
  return /*#__PURE__*/_jsx(InitialPageContentWrapperV2, {
    widgetLocation: widgetLocation,
    isMobile: isMobile,
    usePillLauncher: usePillLauncher,
    children: children
  });
};
InitialPageContentWrapper.displayName = 'InitialPageContentWrapper';
export default InitialPageContentWrapper;